import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import PublicLayout from './pages/PublicLayout'
import Sidebar from './components/Sidebar'
import Home from './pages/Home'
import QuemSomos from './pages/QuemSomos'
import Servicos from './pages/Servicos'
import Produtos from './pages/Produtos'
import Tecnologia from './pages/Tecnologia'
import Clientes from './pages/Clientes'
import Contato from './pages/Contato'
import './App.css'

const __version = "______42"

function MainContent() {
  return (
    <nav style={{ height: '100vh', width: '100%', overflowY: 'hidden', overflowX: 'hidden', zIndex: 999 }} className="">
      <div style={{ float: 'left', position: 'absolute', zIndex: 1000, paddingTop: '1.2em', paddingLeft: '0.6em' }}>
        <button type="button" id="sidebarCollapse" className="btn btn-primary">
          <i className="fa fa-bars"></i>
          <span className="sr-only">Menu</span>
        </button>
      </div>
      <div style={{ height: '100vh', overflow: 'auto' }}>
        <Routes>
          <Route path="/app/*" element={<Home />} />
          <Route path="/app/quem-somos" element={<QuemSomos />} />
          <Route path="/app/servicos" element={<Servicos />} />
          <Route path="/app/produtos" element={<Produtos />} />
          <Route path="/app/tecnologia" element={<Tecnologia />} />
          <Route path="/app/clientes" element={<Clientes />} />
          <Route path="/app/contato" element={<Contato />} />
        </Routes>
      </div>
    </nav>
  )
}

export default function App() {
  return (
    <Router>
      <Routes>
        {/* Rota padrão para a página pública com iframes */}
        <Route path="/" element={<PublicLayout />} />
        {/* Rotas para a versão React */}
        <Route 
          path="/app/*" 
          element={
            <div className="wrapper d-flex align-items-stretch">
              <Sidebar version={__version} />
              <MainContent />
            </div>
          } 
        />
      </Routes>
    </Router>
  )
}
